export default "__VITE_ASSET__CTFv4ikG__"